/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { StationCreditorInstitution } from "./StationCreditorInstitution";
import { PageInfo } from "./PageInfo";
import * as t from "io-ts";

// required attributes
const StationCreditorInstitutionsR = t.interface({
  creditor_institutions: t.readonlyArray(
    StationCreditorInstitution,
    "array of StationCreditorInstitution"
  ),

  page_info: PageInfo
});

// optional attributes
const StationCreditorInstitutionsO = t.partial({});

export const StationCreditorInstitutions = t.intersection(
  [StationCreditorInstitutionsR, StationCreditorInstitutionsO],
  "StationCreditorInstitutions"
);

export type StationCreditorInstitutions = t.TypeOf<
  typeof StationCreditorInstitutions
>;
